"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8655],{

/***/ 34024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLexusArrow = function SvgLexusArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.03 7.47a.75.75 0 1 0-1.06 1.06l.72.72H1.5a.75.75 0 0 0 0 1.5h15.19l-.72.72a.75.75 0 1 0 1.06 1.06L19.56 10l-2.53-2.53Z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLexusArrow);

/***/ }),

/***/ 98655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MV": function() { return /* reexport */ cta; },
  "tv": function() { return /* reexport */ customLogoNav; },
  "hG": function() { return /* reexport */ draw; },
  "TR": function() { return /* reexport */ logo/* default */.Z; },
  "JL": function() { return /* reexport */ nav; }
});

// UNUSED EXPORTS: Loader

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/assets/icons/lexusArrow.svg
var lexusArrow = __webpack_require__(34024);
// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var useBrand = __webpack_require__(25765);
;// CONCATENATED MODULE: ./src/components/ui/cta/index.tsx



const CTA = (param)=>{
    let { children , href , theme ="primary" , ...rest } = param;
    const { className: restClassName , ...otherRest } = rest;
    const brand = (0,useBrand/* useBrand */.D)();
    let classes = "".concat(restClassName || "", " ").concat(theme === "secondary" ? "bg-white text-base hover:text-white" : "bg-base text-white", " inline-flex items-center justify-center px-6 py-3 border border-base outline-0 hover:bg-base-hover active:bg-base-hover focus:bg-base-hover disabled:cursor-not-allowed disabled:bg-base-hover  ");
    let inside = children;
    if (brand === "lexus") {
        classes = "".concat(restClassName || "", " group-button inline-flex items-center justify-end !leading-10 pl-4 uppercase rounded bg-secondary text-white outline-0 hover:bg-secondary-hover active:bg-secondary-hover focus:bg-secondary-hover disabled:cursor-not-allowed disabled:bg-secondary-hover");
        inside = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm text-center font-semibold !leading-[44px]",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusArrow/* default */.Z, {
                    className: "ml-2 mr-4 group-button-hover:mx-3"
                })
            ]
        });
    }
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            className: classes,
            ...otherRest,
            children: inside
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classes,
        ...otherRest,
        children: inside
    });
};
/* harmony default export */ var cta = (CTA);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-accordion/dist/index.mjs + 14 modules
var dist = __webpack_require__(87775);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(22656);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(63588);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(15241);
;// CONCATENATED MODULE: ./src/components/ui/draw/index.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 





const AccordionItem = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , className , ...props } = param;
    return (0,jsx_runtime.jsx)(dist/* Item */.ck, {
        className: classnames_default()("mt-px overflow-hidden first:mt-0 focus-within:relative", className),
        ...props,
        ref: forwardedRef,
        children: children
    });
});
AccordionItem.displayName = "AccordionItem";
const AccordionTrigger = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>{
    let { children , className , forceOpen , ...props } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const handleClick = ()=>{
        setIsOpen(!isOpen);
    };
    (0,react.useEffect)(()=>{
        if (forceOpen) {
            setIsOpen(true);
        }
    }, [
        forceOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
        className: "flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Trigger */.xz, {
            className: classnames_default()("group text-xl py-8 !leading-snug flex flex-1 cursor-default items-center justify-between bg-white outline-none hover:cursor-pointer data-[state=closed]:border-b-[1px] border-dark-grey", className),
            ...props,
            "data-gt-name": "componentevent",
            "data-gt-action": isOpen ? "expand" : "reduce",
            "data-gt-label": children,
            ref: forwardedRef,
            onClick: handleClick,
            children: [
                children,
                !forceOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {
                    className: "w-6 h-6 transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:rotate-180",
                    "aria-hidden": true
                })
            ]
        })
    });
});
AccordionTrigger.displayName = "AccordionTrigger";
const AccordionContent = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , className , ...props } = param;
    return (0,jsx_runtime.jsx)(dist/* Content */.VY, {
        className: classnames_default()("overflow-hidden data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown", className),
        ...props,
        ref: forwardedRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: children
        })
    });
});
AccordionContent.displayName = "AccordionContent";
const Draw = (param)=>{
    let { title , data , forceOpen , noContainer  } = param;
    if (!data) {
        return null;
    }
    const { quote  } = data;
    const id = title.replaceAll(" ", "-").toLowerCase();
    const [accordionValue, setAccordionValue] = (0,react.useState)(forceOpen ? "your-quote" : null);
    (0,react.useEffect)(()=>{
        if (forceOpen) {
            setAccordionValue("your-quote");
        } else {
            setAccordionValue(null);
        }
    }, [
        forceOpen
    ]);
    const currency = (value)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            value: value,
            displayType: "text",
            thousandSeparator: true,
            decimalScale: 2,
            fixedDecimalScale: true,
            prefix: "\xa3"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Root */.fC, {
        className: "",
        type: "single",
        collapsible: !forceOpen,
        value: accordionValue,
        onValueChange: setAccordionValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(noContainer ? "" : "container"),
            "data-gt-componentname": "accordion",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem, {
                value: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionTrigger, {
                        forceOpen: forceOpen,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg pb-1",
                                                children: quote.textModel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm",
                                                children: quote.textCarDescBodystyle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm",
                                                children: quote.textCarDescGrade
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm",
                                                children: quote.textCarDescEngine
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: quote.PRINTIMAGESRC,
                                            alt: quote.textModel,
                                            className: "w-full max-w-[300px]"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-x-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-y border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                            children: [
                                                                "1",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                    children: "st"
                                                                }),
                                                                " Monthly Payment"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.FirstPayment)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                            children: [
                                                                "Next ",
                                                                quote.PAYMENT_NORMAL_NUMBER,
                                                                " Payments"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.PAYMENT_NORMAL)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Customer Deposit"
                                                        }),
                                                        quote.DEPOSIT_REQUESTED > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.DEPOSIT_REQUESTED)
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.Deposit - quote.FDA_AMOUNT)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Cash Price"
                                                        }),
                                                        quote.CUST_SAVE_AMOUNT > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.OtrPrice - quote.CUST_SAVE_AMOUNT)
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.OtrPrice)
                                                        })
                                                    ]
                                                }),
                                                quote.FDA_AMOUNT > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Finance Deposit Allowance"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.FDA_AMOUNT)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b md:border-y border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Amount of Credit"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.AMOUNT_CREDIT)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Guarenteed Future Value / Optional Final Payment"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.FinalPayment)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Total Amount Payable"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            className: "font-semibold",
                                                            children: currency(quote.TOTAL_AMOUNT_PAYABLE)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Term"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                            className: "font-semibold",
                                                            children: [
                                                                quote.Term,
                                                                " months"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between gap-4 py-4 border-b border-dark-grey",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "Representative"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                            className: "font-semibold",
                                                            children: [
                                                                quote.APR,
                                                                "% APR"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var draw = (Draw);

;// CONCATENATED MODULE: ./src/components/ui/loader/index.tsx

const Loader = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "loader absolute m-auto !top-[50%] inset-x-0 overflow-hidden !border-l-base",
        children: "Loading..."
    });
};
/* harmony default export */ var loader = ((/* unused pure expression or super */ null && (Loader)));

// EXTERNAL MODULE: ./src/components/ui/logo/index.tsx + 5 modules
var logo = __webpack_require__(38364);
// EXTERNAL MODULE: ./src/contexts/index.tsx + 96 modules
var contexts = __webpack_require__(28798);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(56572);
;// CONCATENATED MODULE: ./src/components/ui/nav/stepper.tsx

const Stepper = (param)=>{
    let { steps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row",
        children: steps && steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(index > 0 ? "ml-[30px]" : ""),
                children: step
            }, index))
    });
};
/* harmony default export */ var stepper = (Stepper);

// EXTERNAL MODULE: ./src/components/ui/nav/title.tsx
var nav_title = __webpack_require__(97441);
;// CONCATENATED MODULE: ./src/components/ui/nav/index.tsx






const getLogoWidth = (brand, logoType)=>{
    const type = logoType || brand;
    switch(type){
        case "kinto":
            return "w-[80px] mt-[2px]";
        case "lexus-kinto":
            return "w-[160px] mt-[2px]";
        case "toyota-kinto":
            return "w-[160px] mt-[2px]";
        case "lexus":
        case "toyota":
        default:
            return "w-[50px] lg:w-[65px]";
    }
};
// TODO: Fix to work with kinto and background types??
const Nav = (param)=>{
    let { title , steps , background , color , logoType  } = param;
    const brand = (0,contexts/* useBrand */.DY)();
    // const query = useQuery()
    // const [group, setGroup] = useState(null)
    // useEffect(() => {
    //   const data = async () => {
    //     if (query?.group) {
    //       const url = `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/toyota/gb/en/operating-companies/all?uuid=${query.group}`
    //       try {
    //         const response = await fetch(url)
    //         if (!response.ok) {
    //           throw new Error('Network response was not ok')
    //         }
    //         let res = await response.json()
    //         res = res.operatingCompanies.filter((i) => i.uuid === query.group)
    //         setGroup(res[0])
    //       } catch (error) {
    //         setGroup(null)
    //       }
    //     }
    //   }
    //   data()
    // }, [query])
    // TODO: Figure out what this is doing
    const imageUrl = "https://scene7.toyota.eu/is/image/toyotaeurope/".concat(background, "?qlt=80&wid=1920&hei=1080&fit=crop,1");
    const logoWidth = getLogoWidth(brand, logoType);
    const StepsNav = steps ? /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (0,bundle_mjs/* twMerge */.m6)("bg-primary sticky top-0 z-10 py-3 md:py-4 lg:py-6 text-base-text", brand === "lexus" && " uppercase"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container h-[50px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stepper, {
                steps: steps
            })
        })
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: background ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: (0,bundle_mjs/* twMerge */.m6)("pt-6 pb-8 md:py-8 lg:pt-10 lg:pb-12 h-[300px] md:h-[350px] lg:h-[500px]", steps ? "!pb-0" : "", brand === "lexus" && " uppercase", color === "white" && "text-white"),
                    style: {
                        background: "no-repeat 50% 50% / cover url(".concat(background.src ? background.src : imageUrl, ")")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container flex items-center text-base-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                width: "65",
                                className: (0,bundle_mjs/* twMerge */.m6)("logo ".concat(logoWidth, " shrink-0"), color === "white" && "text-white"),
                                logoType: logoType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_title/* default */.Z, {
                                children: title
                            })
                        ]
                    })
                }),
                StepsNav
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (0,bundle_mjs/* twMerge */.m6)("bg-primary pt-6 pb-8 md:py-8 lg:pt-10 lg:pb-12 shadow-header", steps && "!pb-0", brand === "lexus" && " uppercase"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container flex items-center text-base-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                            width: "65",
                            className: "logo ".concat(logoWidth, " shrink-0"),
                            logoType: logoType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_title/* default */.Z, {
                            children: title
                        })
                    ]
                }),
                StepsNav
            ]
        })
    });
};
/* harmony default export */ var nav = (Nav);

;// CONCATENATED MODULE: ./src/assets/logos/toyota-lexus.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgToyotaLexus = function SvgToyotaLexus(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.67 75.72"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M133 0h2.53v75.72H133zM58.11.28C26.02.28 0 17.11 0 37.87s26.02 37.58 58.11 37.58 58.12-16.83 58.12-37.58S90.21.28 58.11.28Zm0 59.04c-4.77 0-8.67-9.4-8.92-21.23a99.603 99.603 0 0 0 17.84 0c-.25 11.83-4.15 21.23-8.92 21.23ZM49.79 28.7c1.3-8.36 4.54-14.29 8.32-14.29s7.03 5.92 8.33 14.29c-2.66.24-5.45.37-8.33.37s-5.66-.14-8.32-.37Zm8.32-22.98c-6.24 0-11.55 9.33-13.51 22.35-11.82-1.84-20.07-6.04-20.07-10.92 0-6.59 15.04-11.91 33.58-11.91s33.58 5.33 33.58 11.91c0 4.88-8.25 9.07-20.07 10.92-1.96-13.02-7.27-22.35-13.51-22.35ZM8.33 36.46c0-6.37 2.45-12.34 6.72-17.48-.05.37-.07.73-.07 1.1 0 8.03 12.04 14.86 28.83 17.38v1.76c0 14.96 4.19 27.62 9.98 31.92-25.48-1.55-45.46-16.5-45.46-34.68Zm54.11 34.66c5.79-4.3 9.99-16.96 9.99-31.92v-1.76c16.79-2.52 28.83-9.35 28.83-17.38 0-.37-.03-.74-.08-1.1 4.28 5.14 6.72 11.1 6.72 17.48 0 18.19-19.99 33.15-45.47 34.68ZM257.66 2.31l-1.38 2.08c9.27 3.81 13.03 10.74 13.03 18.16 0 3.71-1.01 7.06-2.96 7.06h-24.32c-3.32 0-4.3-1.18-2.81-4.12 2.65-5.25 10.63-15.29 15.54-21.33.72-.89 1.31-2.27-1.27-2.96-2.64-.71-6.9-1-10.51-1-18.29 0-31.04 9.89-31.04 22.64 0 11.73 11.06 22.69 30.99 22.69 8.81 0 19.61-2.48 25.74-9.42h-5.28c-5.97 5.39-13.76 6.62-20.41 6.62-16.09 0-26.27-8.35-26.27-19.89 0-10.64 11.53-20.19 26.07-20.19 1.74 0 2.31.37.47 2.66-3.72 4.62-10.37 13.77-13.49 19.13-3.34 5.74.07 10.41 7.58 10.41h30.42c1.88 0 2.94-1.07 4.04-3.01.87-1.56 2.25-4.71 2.25-8.99 0-8.65-6.49-16.59-16.38-20.54ZM325.89 61.9h-20.63c.68-2.64 2.72-4.45 6.56-4.45h19.74v-4.43h-20.98c-11.97 0-14.81 8.51-14.81 13.31h25.55c3.51 0 3.51 4.73.12 4.73H293.2V53.01h-8.51v18.05h-14.11c-3.78 0-5.37-1.81-5.37-4.62V53.02h-13.63l-12.18 7.67-10.5-7.67h-30.21c-8.75 0-14.97 5.11-15.69 11.5h5.68c-2.29 1.48-4.04 3.9-5.02 6.58h-17.87c-3.37 0-4.94-1.75-4.94-5.05V53.01h-8.54V64.1c0 7.04 3.84 11.47 12.5 11.47h59.58l12.24-7.71 10.55 7.71h12.58l-16.37-11.96 13.3-8.37v12.67c0 3.93 5.09 7.66 9.72 7.66h59.53c10.35 0 10.28-13.67-.04-13.67Zm-103.03 9.2h-28.91c.3-2.41 1.55-4.82 5.5-4.82h17.92v-4.41h-23.86c.41-1.82 2.27-4.42 6.57-4.42h18.95V55l13.6 9.94-9.78 6.16Z"
  })));
};
/* harmony default export */ var toyota_lexus = (SvgToyotaLexus);
;// CONCATENATED MODULE: ./src/assets/logos/toyota-professional.svg
var toyota_professional_path;
function toyota_professional_extends() { toyota_professional_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toyota_professional_extends.apply(this, arguments); }

var SvgToyotaProfessional = function SvgToyotaProfessional(props) {
  return /*#__PURE__*/react.createElement("svg", toyota_professional_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1037.75 230.67"
  }, props), toyota_professional_path || (toyota_professional_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M481.24 28.56h-20.19V92.8H446.3V28.56h-20.41V15.75h55.35ZM479.61 65.35c0-16.49 12.15-28.54 29.84-28.54s29.74 12 29.74 28.54S527 93.89 509.45 93.89s-29.84-12.05-29.84-28.54Zm45.58-.11c0-9.44-6.41-15.95-15.74-15.95s-15.84 6.51-15.84 16.06 6.51 16.06 15.84 16.06 15.74-6.62 15.74-16.17ZM597.67 37.89l-24 61.75c-4.13 10.75-10.31 16.17-21.06 16.17a24.81 24.81 0 0 1-9.11-1.52l1.62-11.61a14.68 14.68 0 0 0 5 .87c5 0 8.68-1.85 11.28-7.92l2.06-5-22.22-52.74h14.86l14.44 37.33 13-37.33ZM599.88 65.35c0-16.49 12.15-28.54 29.85-28.54s29.73 12 29.73 28.54-12.16 28.54-29.73 28.54-29.85-12.05-29.85-28.54Zm45.58-.11c0-9.44-6.4-15.95-15.73-15.95s-15.85 6.51-15.85 16.06 6.51 16.06 15.85 16.06 15.73-6.62 15.73-16.17ZM673.31 75.88V49.29h-8.47v-11.4h8.47V22.48l13.56-1.73v17.14h14.87v11.4h-14.87V74c0 5.21 2.39 7.6 6.51 7.6a20.2 20.2 0 0 0 9.44-2.93l2.17 11a27.1 27.1 0 0 1-14.86 4.23c-10.53-.01-16.82-5.9-16.82-18.02ZM760.66 58.19V92.8H747.2v-7.59c-3.47 5-10.09 8.79-18.56 8.79-10.74 0-17.8-6.19-17.8-16.39 0-12.81 11.29-17.58 36.25-17.9v-1.09c0-6.51-3.8-10.64-12.15-10.64a30.3 30.3 0 0 0-17.15 5.76L714.64 43a43.72 43.72 0 0 1 22.68-6.18c14.11-.01 23.34 6.5 23.34 21.37Zm-13.57 13.56v-3.69c-16.6.33-22.14 2.82-22.14 8.79 0 4.34 3 7.06 8.58 7.06 6.61 0 13.56-3.69 13.56-12.16ZM482.21 158.54c0 12.91-9 24.63-25.93 24.63H443v28.76h-8.1v-77.05h21.38c16.93 0 25.93 9.34 25.93 23.66Zm-8.35 0c0-12.37-8.14-16.5-18.45-16.5H443v34h12.37c10.35-.04 18.49-6.32 18.49-17.5ZM523.49 157.45l-1.84 7.38a17.36 17.36 0 0 0-5.53-1.08c-9.12 0-13.35 8-13.35 19.2v29h-7.49v-54.5h7.49v9.77c3.14-8.14 7.92-11 14.1-11a17.54 17.54 0 0 1 6.62 1.23ZM527.55 184.69c0-16.6 11.72-28.32 28.54-28.32s28.55 11.72 28.55 28.32S572.92 213 556.09 213s-28.54-11.71-28.54-28.31Zm49.38 0c0-12.59-8.68-21.05-20.84-21.05-12.37 0-20.72 8.57-20.72 20.94 0 12.7 8.57 21.16 20.72 21.16 12.38 0 20.84-8.57 20.84-21.05ZM599.92 164.07h-9.55v-6.62h9.55v-9.77c0-11.71 5.65-17.57 14.76-17.57a23.43 23.43 0 0 1 10 2.27l-1.74 6.84a14.88 14.88 0 0 0-7.38-2.06c-4.88 0-8 2.71-8 11.07v9.22h13.35v6.62h-13.39v47.86h-7.6ZM678.33 185.23h-44.71c.32 12.81 8.46 20.84 21 20.84a29.37 29.37 0 0 0 19.85-7.6l2.17 6.73c-4.66 4.23-12.8 7.82-22.46 7.82-17.47 0-28.21-12.7-28.21-28.33 0-16.28 11.5-28.32 26.8-28.32s25.61 11.61 25.61 27.89Zm-8-6c-1.2-9.34-7.81-16.18-17.58-16.18-9 0-16.93 6.52-18.67 16.18ZM687.81 207.16l2.06-6.73a27.41 27.41 0 0 0 17.37 6.18c7.49 0 12.15-3.47 12.15-9.11s-4.88-7.27-13.45-10c-8.25-2.49-16.5-5.42-16.5-15.51 0-9.77 7.81-15.63 19.21-15.63a31.3 31.3 0 0 1 16.49 4.56l-1.63 6.72a28 28 0 0 0-15.08-4.88c-6.84 0-11.39 3.15-11.39 8.46 0 5.75 5.64 7.71 12.58 9.66 9.23 2.61 17.26 5.86 17.26 15.85 0 9.65-7.38 16.28-20.08 16.28-7.59-.01-15.19-2.49-18.99-5.85ZM737.12 207.16l2.07-6.73a27.38 27.38 0 0 0 17.36 6.18c7.49 0 12.15-3.47 12.15-9.11s-4.88-7.27-13.45-10c-8.25-2.49-16.5-5.42-16.5-15.51 0-9.77 7.82-15.63 19.21-15.63a31.34 31.34 0 0 1 16.5 4.56l-1.63 6.72a28 28 0 0 0-15.09-4.88c-6.83 0-11.39 3.15-11.39 8.46 0 5.75 5.64 7.71 12.59 9.66 9.22 2.61 17.25 5.86 17.25 15.85 0 9.65-7.38 16.28-20.07 16.28-7.6-.01-15.2-2.49-19-5.85ZM788.17 139.76a5.75 5.75 0 1 1 5.75 5.76 5.66 5.66 0 0 1-5.75-5.76Zm1.83 17.69h7.6v54.48H790ZM811.12 184.69c0-16.6 11.72-28.32 28.54-28.32s28.55 11.72 28.55 28.32S856.49 213 839.66 213s-28.54-11.71-28.54-28.31Zm49.38 0c0-12.59-8.68-21.05-20.84-21.05-12.37 0-20.72 8.57-20.72 20.94 0 12.7 8.57 21.16 20.72 21.16 12.34 0 20.84-8.57 20.84-21.05ZM929.41 178.61v33.32h-7.6v-31.25c0-11.4-5-17.37-14.43-17.37-10.2 0-17.58 7.38-17.58 17.58v31h-7.6v-54.44h7.6v10.09c3.58-6.83 10.63-11.17 20-11.17 12.12 0 19.61 7.27 19.61 22.24ZM989.6 178.07v33.86h-7.48v-9.55c-3.37 6.08-10.64 10.64-20.41 10.64-11.72 0-18.55-6.3-18.55-16.18 0-12.26 10.52-17.14 38.85-17.36v-1.41c0-9-5.21-15-15.41-15a29 29 0 0 0-17.91 6.63l-2.17-6.84a36 36 0 0 1 21.16-6.51c13.78.02 21.92 7.18 21.92 21.72Zm-7.6 12.37V185c-23.77.21-30.93 3.69-30.93 11.61 0 6.08 4.23 10.09 12.15 10.09 8.37.02 18.78-4.43 18.78-16.26ZM1006.76 200v-69.68h7.59v68.59c0 5.1 2.07 7.16 5.32 7.16a15.24 15.24 0 0 0 5.65-1.41l1.19 6.4a18.1 18.1 0 0 1-8.57 2c-6.84-.06-11.18-4.06-11.18-13.06ZM377.13 15.76h6.9v196.17h-6.9zM173.23 13C85.84 13 15 58.82 15 115.34s70.84 102.33 158.23 102.33 158.24-45.82 158.24-102.33S260.62 13 173.23 13Zm0 160.74c-13 0-23.6-25.59-24.28-57.8 7.83.71 16 1.08 24.28 1.08s16.45-.37 24.29-1.08c-.69 32.21-11.3 57.8-24.29 57.8Zm-22.66-83.35c3.54-22.77 12.35-38.9 22.66-38.9s19.13 16.13 22.67 38.9c-7.25.65-14.84 1-22.67 1s-15.41-.39-22.66-1Zm22.66-62.57c-17 0-31.44 25.4-36.78 60.84-32.18-5-54.65-16.44-54.65-29.72 0-17.94 40.94-32.44 91.43-32.44s91.43 14.5 91.43 32.44c0 13.28-22.46 24.69-54.64 29.72-5.34-35.44-19.8-60.84-36.79-60.84ZM37.69 111.5c0-17.35 6.67-33.6 18.3-47.58a22.53 22.53 0 0 0-.2 3c0 21.86 32.78 40.46 78.5 47.31v4.8c0 40.72 11.42 75.2 27.18 86.9C92.09 201.71 37.69 161 37.69 111.5ZM185 205.89c15.77-11.7 27.19-46.18 27.19-86.9v-4.8c45.72-6.85 78.5-25.45 78.5-47.31a20.94 20.94 0 0 0-.21-3c11.64 14 18.31 30.23 18.31 47.58-.01 49.54-54.42 90.25-123.79 94.43Z"
  })));
};
/* harmony default export */ var toyota_professional = (SvgToyotaProfessional);
;// CONCATENATED MODULE: ./src/components/ui/nav/customLogoNav.tsx





const CustomLogoNav = (param)=>{
    let { title , businessName  } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "bg-primary p-6 lg:p-10 ".concat(brand === "lexus" && " uppercase"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col gap-6",
            children: [
                businessName === "toyota-lexus" && /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota_lexus, {
                    width: "185"
                }),
                businessName === "toyota-professional" && /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota_professional, {
                    width: "215"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_title/* default */.Z, {
                    className: "!ml-0",
                    children: title
                })
            ]
        })
    });
};
/* harmony default export */ var customLogoNav = (CustomLogoNav);

;// CONCATENATED MODULE: ./src/components/ui/index.ts









/***/ }),

/***/ 97441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

const PageTitle = (param)=>{
    let { children , className , reverse  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        className: "".concat(reverse ? "" : "ml-4", " text-xl leading-normal md:text-2xl lg:text-3xl ").concat(className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ })

}]);